import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {isMasterUser, isCareSheetsSupported} = customer.selectors;



import {initializePermissionTable, registerUser, toggleUserPermission} from '../actions';
import {getSelectedPermissions} from '../selectors';

import CreateUserForm from './CreateUserForm';

const formName = 'createUserForm';

class CreateUserPage extends React.Component {
  componentWillMount() {
    if(!this.props.isMasterUser)
    {
      this.props.actions.push('/labels');
    } 

    this.props.actions.initializePermissionTable();
  }

  handleFormSubmit = (values, dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(registerUser(values, this.props.permissionTable))
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  handleFormCancel = () => {
    this.props.actions.push('/users');
  }

  handleFormValidation = (values) => {
    const errors = {};

    if(!values.firstName) {
      errors.firstName = I18n.t('PLEASE_ENTER_FIRST_NAME');
    }

    if(!values.lastName) {
      errors.lastName = I18n.t('PLEASE_ENTER_LAST_NAME');
    }

    if (!values.email) {
      errors.email = I18n.t('PLEASE_ENTER_VALID_EMAIL');
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = I18n.t('PLEASE_ENTER_VALID_EMAIL');
    }

    if(values.password === undefined || values.password.length < 8 || values.password.length > 100) {
      errors.password = I18n.t('PASSWORD_CHARACTERS');
    }
    if (values.confirmPassword === undefined || values.password !== values.confirmPassword) {
      errors.confirmPassword = I18n.t('PASSWORDS_DO_NOT_MATCH');
    }

    return errors;
  }

  render() {
    const {actions, permissionTable, supportsCareSheets} = this.props;
    return (
      <CreateUserForm form={formName} 
                      onCancel={this.handleFormCancel}
                      onSubmit={this.handleFormSubmit}
                      onTogglePermission={actions.toggleUserPermission}
                      permissionTable={permissionTable}
                      validate={this.handleFormValidation}
                      supportsCareSheet = {supportsCareSheets}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    isMasterUser: isMasterUser(state),
    permissionTable: getSelectedPermissions(state),
    supportsCareSheets: isCareSheetsSupported(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({initializePermissionTable, registerUser, toggleUserPermission, push}, dispatch)
  };
}

CreateUserPage.propTypes = {
  actions: PropTypes.object.isRequired,
  isMasterUser: PropTypes.bool.isRequired,
  permissionTable: PropTypes.array.isRequired,
  supportsCareSheets: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserPage);


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/CreateUserPage.js
 **/